module.exports = __webpack_public_path__ + "static/media/Icons-20x20-Radiobutton_selected_Light Blue.d642a05a.svg";